<template>
  <div class="slide">
    <div class="image">
      <img :src="slide.image.sizes.slide" width="700" height="400">
    </div>
    <div class="content">
      <div v-html="slide.content"></div>
      <p v-if="slide.button_link !== 'none'">
        <a class="btn btn-lg btn-primary" :href="slide.button_link_external" v-if="slide.button_link === 'ext'" target="_blank">{{ slide.button_link_text }}</a>
        <router-link class="btn btn-lg btn-primary" :to="internalLink" v-if="slide.button_link === 'int'">{{ slide.button_link_text }}</router-link>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'slide',
  props: ['slide', 'index'],
  computed: {
    isHashLink () {
      const postName = this.slide.button_link_internal.post_name
      return (postName === 'donate' || postName === 'events' || postName === 'contact')
    },
    internalPostName () {
      const slide = this.slide
      if (slide.button_link_internal) {
        return slide.button_link_internal.post_name === 'home' ? '' : slide.button_link_internal.post_name
      }
    },
    internalLink () {
      const slide = this.slide
      if (slide.button_link_internal) {
        return (this.isHashLink) ? '/#' + this.internalPostName : '/' + this.internalPostName
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Slide.vue?1996b33b